import { useState, useEffect, useRef } from "react";
import NavBar from "../common/navBar/navBar";
import Footer from "../common/footer/footer";
import "./home.css";
import postImages from "./posts";
import { Link } from "react-router-dom";
import { getAllPost } from "../common/api/postApi";
import { toast } from "react-toastify";

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef(null);
  const [scrollIndex, setScrollIndex] = useState(0);
  const [post, setPost] = useState([]);
  const [loading, setLoading] = useState(true);
  const postWidth = 250;
  const visibleCards = 3;

  useEffect(() => {
    // setPostState(posts);
    getAllPosts();
  }, []);

  const slides = [
    {
      content: <img src="/assets/homeSlider/Slide1.jpg" alt="Slide 1" />,
    },
    {
      content: (
        <video src="/assets/homeSlider/Slide2.mp4" autoPlay loop muted />
      ),
    },
    {
      content: (
        <video src="/assets/homeSlider/Slide3.mp4" autoPlay loop muted />
      ),
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [slides.length]);

  const handleScrollLeft = () => {
    if (scrollIndex > 0) {
      setScrollIndex(scrollIndex - 1);
    }
  };

  const handleScrollRight = () => {
    const maxScroll = post.length - visibleCards;
    if (scrollIndex < maxScroll) {
      setScrollIndex(scrollIndex + 1);
    }
  };
  const getAllPosts = async () => {
    let res = await getAllPost();
    setLoading(true);
    if (res && res.data.responseCode === 200) {
      const apiData = res.data.data;
      const mergedPosts = apiData.map((post, index) => ({
        ...post,
        img: postImages[index]?.img || null,
      }));

      setPost(mergedPosts);
      setLoading(false);
    } else if (res && res.data.responseCode === 400) {
      toast.error(res.data.errMessage);
    } else {
      toast.error("Something went wrong! ");
    }
  };
  const limitText = (text, limit) => {
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };
  return (
    <>
      <NavBar />
      {/* Slides */}
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? "active" : ""}`}
          >
            {slide.content}
          </div>
        ))}
      </div>

      {/* Feartured Posts */}
      <section className="featured-posts">
        <h2
          className="fw-bold"
          style={{ margin: "40px", textAlign: "center", color: "#7860cc" }}
        >
          Featured Posts
        </h2>
        <div className="post-container">
          {/* Left button */}
          <button
            className="navigation-button left p-2"
            style={{ borderRadius: "50%" }}
            onClick={handleScrollLeft}
          >
            &#8249;
          </button>

          {/* Posts list */}
          <div className="posts-list">
            <div
              className="posts-slider"
              ref={scrollRef}
              style={{
                transform: `translateX(-${scrollIndex * postWidth}px)`,
              }}
            >
              {loading ? (
                <div class="spinner-border text-primary mx-auto mb-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                post.map((post) => (
                  <div
                    className="post p-2"
                    key={post.id}
                    style={{
                      margin: "10px",
                      boxShadow:
                        " rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                      borderRadius: "15px",
                    }}
                  >
                    <div className="post-content">
                      {post.img && (
                        <img
                          src={post.img}
                          alt={`Post ${post.id}`}
                          style={{
                            height: "120px",
                            display: "block",
                            margin: "0 auto",
                          }}
                        />
                      )}
                      <p
                        className="px-2 mb-0 fw-bold mt-2"
                        style={{ fontSize: "22px" }}
                      >
                        {post.title}
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: limitText(post.content, 130),
                        }}
                        className="my-3 mb-0"
                      />
                      <Link
                        to={`/post/blogdetailpage`}
                        state={post}
                        className="text-primary mb-2"
                        style={{ textDecoration: "none" }}
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Right button */}

          <button
            className="navigation-button right"
            onClick={handleScrollRight}
          >
            &#8250;
          </button>
        </div>
      </section>

      {/* Computer Screen */}
      <div className="homepage z-n1">
        <main>
          <div
            class="codeeditorbr-container mt-5"
            style={{ textAlign: "left" }}
          >
            <div class="codeeditorbr-row">
              <div class="codeeditorbr-column codeeditorbr-left">
                <span
                  class="codeeditorbr-dot"
                  style={{ background: "#ED594A" }}
                ></span>
                <span
                  class="codeeditorbr-dot"
                  style={{ background: "#FDD800" }}
                ></span>
                <span
                  class="codeeditorbr-dot"
                  style={{ background: "#5AC05A" }}
                ></span>
              </div>

              <div class="codeeditorbr-column codeeditorbr-middle">
                <input
                  type="text"
                  disabled
                  class="codeeditorbr-input fw-semibold"
                  value="https://devDiaries.com"
                  aria-label="Select template"
                />
              </div>
            </div>
            <video width="100%" height="400px" controls></video>
          </div>

          <div style={{ position: "relative" }}>
            <div class="vl-howto"></div>
          </div>
          <Link
            href=""
            class="w3-button ga-fp tut-button ws-black w3-padding-16 w3-mobile vl-howtobtn mb-5"
            style={{ fontSize: "20px" }}
          >
            See it in action
          </Link>
        </main>
      </div>
      {/* Footer */}
      <footer>{<Footer />}</footer>
    </>
  );
}

export default Home;
